export const isCostDealType = (dealType: string) => dealType === "cost";
export const isB2BDealType = (dealType: string) => dealType === "b2b";
export const isB2CDealType = (dealType: string) => dealType === "b2c";
